import { Color } from 'ng2-charts';

import { Theme } from '@recruitee/theme';

// eslint-disable-next-line max-lines-per-function
export const getChartColorsSet = function (colors: Theme): Color[] {
  return colors
    ? [
        {
          backgroundColor: colors.colorCandidatesBgPrimaryDefault,
          borderColor: colors.colorCandidatesBorderPrimaryDefault,
        },
        {
          backgroundColor: colors.colorCandidatesBgGreenStrongDefault,
          borderColor: colors.colorCandidatesBorderGreenStrongDefault,
        },
        {
          backgroundColor: colors.colorCandidatesBgOrangeDefault,
          borderColor: colors.colorCandidatesBorderOrangeDefault,
        },
        {
          backgroundColor: colors.colorCandidatesBgYellowDefault,
          borderColor: colors.colorCandidatesBorderYellowDefault,
        },
        {
          backgroundColor: colors.colorCandidatesBgGreenSubduedDefault,
          borderColor: colors.colorCandidatesBorderGreenSubduedDefault,
        },
        {
          backgroundColor: colors.colorCandidatesBgBlueDefault,
          borderColor: colors.colorCandidatesBorderBlueDefault,
        },
        {
          backgroundColor: colors.colorCandidatesBgVioletDefault,
          borderColor: colors.colorCandidatesBorderVioletDefault,
        },
        {
          backgroundColor: colors.colorCandidatesBgGreenDefault,
          borderColor: colors.colorCandidatesBorderGreenDefault,
        },
        {
          backgroundColor: colors.colorCandidatesBgBlueStrongDefault,
          borderColor: colors.colorCandidatesBorderBlueStrongDefault,
        },
        {
          backgroundColor: colors.colorCandidatesBgPurpleDefault,
          borderColor: colors.colorCandidatesBorderPurpleDefault,
        },
      ]
    : chartColorsSet;
};

// following array should stay as a default color set before theme colors are resolved and the above method is executed
export const chartColorsSet: Color[] = [
  {
    backgroundColor: 'rgb(25, 153, 227)',
    borderColor: 'rgb(25, 153, 227)',
  },
  {
    backgroundColor: 'rgb(30, 162, 117)',
    borderColor: 'rgb(30, 162, 117)',
  },
  {
    backgroundColor: 'rgb(222, 102, 3)',
    borderColor: 'rgb(222, 102, 3)',
  },
  {
    backgroundColor: 'rgb(244, 187, 38)',
    borderColor: 'rgb(244, 187, 38)',
  },
  {
    backgroundColor: 'rgb(49, 189, 149)',
    borderColor: 'rgb(49, 189, 149)',
  },
  {
    backgroundColor: 'rgb(12, 96, 144)',
    borderColor: 'rgb(12, 96, 144)',
  },
  {
    backgroundColor: 'rgb(81, 47, 162)',
    borderColor: 'rgb(81, 47, 162)',
  },
  {
    backgroundColor: 'rgb(79, 197, 16)',
    borderColor: 'rgb(79, 197, 16)',
  },
  {
    backgroundColor: 'rgb(8, 63, 94)',
    borderColor: 'rgb(8, 63, 94)',
  },
  {
    backgroundColor: 'rgb(154, 76, 182)',
    borderColor: 'rgb(154, 76, 182)',
  },
];
